import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The live stream is the source of freshness; refetching on every window
      // focus would fight it and cause visible list churn.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

export const queryKeys = {
  session: ['session'] as const,
  status: ['system', 'status'] as const,
  targets: ['targets'] as const,
  tags: ['tags'] as const,
  posts: (scope: string, params: unknown) => ['posts', scope, params] as const,
};
